(ns iris.styles.posts
  (:require
   ;;    [herb.core :refer [<class <id]]
   ;;  [garden.units :refer [px]]
   [shadow.css :refer [css]]))



(def $container
  (css
   :w-auto
   ["@media (min-width: 748px)" {:width "748px"}]))

;; NOTE:
;; there is app.css code that overrides $post-screening-options:
;; .post-wrap.mobile article footer .ip-buttons .btn {
;;     padding: 5px 10px;
;;     margin: 2px 4px 2px 0
;; }
(defn $post-screening-options [mobile]
  (when (true? mobile)
    (css
     ["&>a" {:padding "5px 10px !important"
             :margin "2px 4px 2px 0"}])))

(defn $counter-red [r n]
  (when (>= n r)
    (css {:font-weight "bold"
          :color "rgb(169, 68, 66)"})))


(def $moderator-logs
  (css {:display "block"
        :width "100%"
        :height "100%"
        :position "fixed"
        :right "0"
        :top "50px"
        :background-color "navy"
        :color "white"
        :overflow-y "auto"
        :z-index "1"}
       ;;  ["@media (min-width: 768px)" {:display "block"
       ;;                                :width "300px"}]
       ;;  ["@media (min-width: 1180px)" {:display "block"
       ;;                                 :width "350px"}]
       ;;  ["@media (min-width: 1800px)" {:display "block"
       ;;                                 :width "400px"}]
       ["@media (min-width: 768px)" {:display "block"
                                     :width "400px"
                                     :top "25px"}]
       ["&>h3" {:font-family "inherit"
                :font-size "20px"
                :margin "5px 10px"}]
       ["&>p" {:font-family "inherit"
               :margin "5px 10px"}]
       ["&>ul" {:list-style "none" :padding "0" :margin-bottom "55px"}]
       ["&>ul>li" {:background-color "lightcyan"
                   :margin "5px"
                   :border-radius "3px"}]
       ["&>ul>li:nth-child(even)" {:background-color "mintcream"}]
       ["&>ul>li>a" {:display "inline-block"
                     :padding "5px 25px"
                     :text-decoration "none"
                     :color "darkblue"}]
       ["&>ul>li>a:hover" {:color "#666"
                           :text-decoration "none"
                           :cursor "pointer"}]
       ["&>ul>li.moderator-logs-empty-list" {:background-color "lightslategrey"
                                             :margin "5px"
                                             :border-radius "3px"
                                             :padding "5px 10px"
                                             :text-align "center"}]))

(def $all-moderator-logs-ul
  (css {:margin "0"
        :padding "0 0 0 20px"
        :position "relative"
        :list-style-type "disc"}))

(def $all-moderator-logs-more-btn
  (css {:float "right"
        :list-style "none"}
       ["@media (min-width: 480px)" {:position "absolute"
                                     :right "0"
                                     :bottom "0"
                                     :cursor "pointer"}]))

(def $filter-display-labels
  (css
   {:display "none"}
   ["@media (min-width: 1024px)" {:display "inline"}]))



(def $post-ref-refresh
  (css
   {:color "#000"
    :opacity "0.25"
    :font-size "12px"}
   [:hover {:opacity "0.5"}]))


(def $post-ref-status
  (css {:float "right"
        :font-weight "bold"
        :color "#666"}
       [:hover {:color "#333"}]))



;; (def $moderator-logs-empty-list
;;   (css {:background-color "lightslategrey"
;;         :margin "5px"
;;         :border-radius "3px"
;;         :padding "5px 10px"
;;         :text-align "center"}))


;; (defn container []
;;   ^{:media {{:screen :only :min-width "748px"} {:width "748px"}}}
;;   {:width "auto"})


;; (defn post-screening-options [mobile]
;;   ^{:combinators {[:> :a]  (when (true? mobile) {:padding "5px 10px !important"
;;                                                  :margin "2px 4px 2px 0"})}}
;;   {})


;; (defn font-size [size]
;;   ;; this works, but... it generates new css class for each resize event and inserts it into stylesheet
;;   ;; also selectors are very, very specific...
;;   ;; decided on a simpler approach, predefined font-size-x classes in styles/general.cljs
;;   ^{:combinators {[:> :.row :article :div :.post-body] {:font-size (str size "% !important")}
;;                   [:> :.row :article :header :.post-title :a] {:font-size (str size "% !important")}
;;                   [:> :.row :article :header :.post-title :span] {:font-size (str size "% !important")}}}
;;   {})

;; (defn counter-red [r n]
;;   (if (>= n r)
;;     {:font-weight "bold"
;;      :color "rgb(169, 68, 66)"}
;;     {}))

;; (defn moderator-logs []
;;   ^{:media {{:screen :only :min-width "1180px"} {:display "block"
;;                                                  :width "200px"}
;;             {:screen :only :min-width "1800px"} {:display "block"
;;                                                  :width "400px"}
;;             {:screen :only :min-width "768px"} {:top "25px"}}}
;;   {
;;   ;;  :display "none"
;;    :display "block"
;;    :width "100%"
;;    :height "100%"
;;    :position "fixed"
;;    :right 0
;;    :top "50px"
;;    :background-color "navy"
;;    :color "white"
;;    :overflow-y "auto"
;;    :z-index 1})

;; (defn moderator-logs-h3 []
;;   {:font-family "inherit"
;;    :font-size "20px"
;;    :margin "5px 10px"})

;; (defn moderator-logs-p []
;;   {:font-family "inherit"
;;    :margin "5px 10px"})

;; (defn moderator-logs-ul []
;;   {:list-style "none" :padding 0 :margin-bottom "55px"})

;; (defn moderator-logs-li []
;;   ^{:pseudo {":nth-child(even)" {:background-color
;;                                 ;;  "rgb(245, 247, 215)"
;;                                  "mintcream"
;;                                  }}}
;;   {:background-color
;;   ;;  "mintcream"
;;   ;;  "khaki"
;;    "lightcyan"
;;    :margin "5px"
;;    :border-radius "3px"})

;; (defn moderator-logs-li-empty-list []
;;   {:background-color "lightslategrey"
;;    :margin "5px"
;;    :border-radius "3px"
;;    :padding "5px 10px"
;;    :text-align "center"})

;; (defn moderator-logs-li-a []
;;   ^{:pseudo {:hover {:color
;;                     ;;  "dimgrey"
;;                      "#666"
;;                        :text-decoration "none"
;;                        :cursor "pointer"}}
;;     :media {{:screen :only :min-width "1180px"} {:padding "5px 10px"}
;;             {:screen :only :min-width "1920px"} {:padding "5px 25px"}}}
;;   {
;;   ;;  :display "block"
;;    :display "inline-block"
;;    :padding "5px 25px"
;;    :text-decoration "none"
;;    :color "darkblue"})


;; (defn all-moderator-logs-ul []
;;   {:margin 0
;;    :padding "0 0 0 20px"
;;    :position "relative"})

;; (defn all-moderator-logs-more-btn []
;;   ^{:media {{:screen :only :min-width "480px"} {:position "absolute"
;;                                                 :right 0
;;                                                 :bottom 0
;;                                                 :cursor "pointer"}}}
;;   {:float "right"
;;    :list-style "none"})

;; (defn filter-display-labels []
;;   ^{:media {{:screen :only :min-width "1024px"} {:display "inline"}}}
;;   {:display "none"})


;; (defn post-ref-refresh []
;;   ^{:pseudo {:hover {:opacity "0.5"}}}
;;   {:color "#000"
;;    :opacity "0.25"
;;    :font-size "12px"})

;; (defn post-ref-status []
;;   ^{:pseudo {:hover {
;;                     ;;  :opacity 0.75
;;                      :color "#333"
;;                      }}}
;;   {:float "right"
;;    :font-weight "bold"
;;    :color "#666"
;;   ;;  :opacity 0.5
;;    }
;;   )



(def $edit-votes-form-container
  (css :flex :justify-center))

(def $edit-votes-form
  ;; (css
  ;;  :flex
  ;;  :items-end
  ;;  :space-x-4)
  (css :flex :flex-wrap :items-end :space-x-4))

(def $edit-votes-form-div
  (css
   :flex :flex-col))


(def $edit-votes-form-label
  ;; (css
  ;;  :block
  ;;  :text-sm
  ;;  :text-gray-700)
  (css :text-sm :font-medium :text-gray-700)
  
  )



(def $edit-votes-form-input
  ;; (css
  ;;  :block
  ;;  :w-20
  ;;  :rounded
  ;;  :border
  ;;  :border-gray-300
  ;;  :px-2
  ;;  :py-1)
  (css 
   :mt-1 :block :w-24 :rounded-md :border :border-gray-300 :px-2 :py-1 :shadow-sm :focus:border-blue-500 :focus:ring-blue-500)
  )

(def $edit-votes-form-button
  ;; (css
  ;;  :h-9
  ;;  :px-4
  ;;  :rounded
  ;;  :bg-blue-600
  ;;  :text-white
  ;;  :hover:bg-blue-700)
  (css
  ;;  :mt-5
   :h-14 :px-4 :rounded-md :bg-blue-600 :text-white :hover:bg-blue-700 :transition))

(def $edit-votes-form-button-container
  ;; (css
  ;;  :flex
  ;;  :items-end
  ;;  :space-x-4)
  (css :flex :flex-col :justify-end)
  )
 


(defn $post-tags-divider [mobile tags]
  (let [$base (css {:display "block"
                    :border "none"
                    :height "1px"
                    :width "90%"
                    :background-color "#dee2e6"})
        $margin (if (and (true? mobile) (pos? (count tags)))
                  (css {:margin "10px auto"})
                  (css {:margin "auto"}))]
    [$base $margin]))